import {
  computed, ref, watch,
} from '@vue/composition-api'

import useRequest from '@/compositions/useRequest'

import MessagesList from '@/components/MessagesList/MessagesList'
import { min } from '@/utils/formatDate'
import MessageNewForm from './components/MessageNewForm/MessageNewForm'
// import MessagesPopup from './components/MessagesPopup/MessagesPopup'
import DialogPreview from './components/DialogPreview/DialogPreview'


export default ({
  components: {
    MessageNewForm, DialogPreview, MessagesList,
  },
  setup(props, context) {
    const { $store } = context.root

    const { loading, makeRequest } = useRequest({
      context,
      request: () => $store.dispatch('messages/fetchOrderMessages'),
    })

    const orderId = ref(null)
    const showNewMessageForm = ref(false)


    const openDialog = (id) => {
      orderId.value = id
    }

    makeRequest()

    const list = computed(() => $store.getters['messages/ordersWithMessagesByDate'])

    const routeParams = computed(() => context.root.$route.query.id)

    watch(() => list.value, () => {
      if (list.value.length) { // если будет пагинация, нужно будет пофиксить логику
        if (routeParams.value) openDialog(Number(routeParams.value))
        else if (!orderId.value && context.root.$mq !== 'sm') openDialog(list.value[0].id)
      }
    })
    watch(() => routeParams.value, (value) => {
      if (value) openDialog(Number(value))
    })

    const formattedDate = date => min(new Date(date))

    const navigate = (id) => {
      context.root.$router.push({ name: 'messagesView', query: { id, type: 'order' } })
    }

    return {
      loading,
      orderId,
      formattedDate,
      showNewMessageForm,
      openDialog,
      list,
      navigate,
    }
  },
})
